import { render } from "./TokenList.vue?vue&type=template&id=3d27f0dc"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TokenList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d27f0dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d27f0dc', __exports__)) {
    api.reload('3d27f0dc', __exports__)
  }
  
  module.hot.accept("./TokenList.vue?vue&type=template&id=3d27f0dc", () => {
    api.rerender('3d27f0dc', render)
  })

}


export default __exports__